<sdps-modal-beta (close)="onModalClose($event)" [attr.sdps-title]="title" id="delete-template-modal">
    <div slot="modal-body">
        <div class="sdps-text-body modal-first-line" class="delete-template-modal-messaging">{{textBody}}</div>
        <div class="sdps-text-body"><strong>Type: </strong>{{transactionType}}</div>
        <div class="sdps-text-body"><strong>Nickname: </strong>{{nickname}}</div>
        <div class="sdps-text-body"><strong>ABA number: </strong>{{bankAba}}</div>
        <div class="sdps-text-body"><strong>Address 1: </strong>{{bankAddress}}</div>
        <div class="sdps-text-body"><strong>Address 2: </strong>{{bankAddressTwo}}</div>
        <div class="sdps-text-body"><strong>Recipient party: </strong>{{recipientParty}}</div>
    </div>
    <div slot="modal-footer">
        <button (click)="onGoBackClick()" type="button"
        class="sdps-button sdps-button--small sdps-button--secondary">No, go back</button>
        <button (click)="onDeleteTemplateClick()" type="button"
        class="sdps-button sdps-button--primary sdps-button--small" id="lc_cancel_continue">Yes, delete</button>
    </div>
</sdps-modal-beta>